// extracted by mini-css-extract-plugin
export default {"recommendForm":"index_recommendForm__0HMEY","resourcePreview":"index_resourcePreview__TU5nD","resourceType":"index_resourceType__Zl7fA"};